/* Lars: I don't think this service is used - may be deleted*/ 

import {
    retrieveAccountNumbersFromFormula as retrieveAccountNumbers,
    checkAccountNumberExistance,
} from '../../utils/accountStructure/accountStructureUtils';
const Parser = require('expr-eval').Parser;

export const scenarioServices = {
    updateAccounts,
    findPeriodsAndAccounts,
    compileScenario,
};

async function updateAccounts(accounts, scenario, organization, periods) {
    let newScenario = { ...scenario };

    accounts.forEach((account) => {
        let newValues = new Array(periods.length).fill(0);
        if (scenario.originalValues.has(account.account_number)) {
            newValues = [...scenario.originalValues.get(account.account_number)];
        }
        newValues[account.index] = account.updatedValue;
        newScenario.originalValues.set(account.account_number, newValues);
    });
    return newScenario;
}

function findPeriodsAndAccounts(
    isPeriodCompiled,
    allAccounts,
    periodQueue,
    accountStructure,
    excludedAccountsAndValues,
) {
    if (Array.isArray(accountStructure)) {
        accountStructure.forEach((account) => {
            if (account['custom_tab_accounts'] === undefined) {
                if (excludedAccountsAndValues !== undefined && excludedAccountsAndValues.has(account.account_number)) {
                    account.formulas.forEach((formula) => {
                        isPeriodCompiled.set(formula.formulas_id, true);
                    });
                } else {
                    account.formulas.forEach((formula) => {
                        isPeriodCompiled.set(formula.formulas_id, false);
                        periodQueue.push({
                            accountNumber: account.account_number,
                            formulasId: formula.formulas_id,
                            period: formula.period,
                        });
                    });
                }
                allAccounts.set(account.account_number, account);
            }

            if (account.children) {
                findPeriodsAndAccounts(
                    isPeriodCompiled,
                    allAccounts,
                    periodQueue,
                    account.children,
                    excludedAccountsAndValues,
                );
            }
        });
    } else {
        for (const key in accountStructure) {
            findPeriodsAndAccounts(
                isPeriodCompiled,
                allAccounts,
                periodQueue,
                accountStructure[key],
                excludedAccountsAndValues,
            );
        }
    }
}

function compileScenario(scenario, allAccounts, periodQueue, isPeriodCompiled) {
    let accountsNotExisting = [];
    let accountsCircular = [];
    let loopCount = 0;

    while (periodQueue.length > 0) {
        const period = periodQueue.shift();
        const account = allAccounts.get(period.accountNumber);
        const isFormula = account.formulas.filter((formula) => formula.formula !== '').length > 0;

        if (loopCount > periodQueue.length) {
            periodQueue.forEach((period) => {
                if (!accountsCircular.includes(period.accountNumber)) {
                    accountsCircular.push(period.accountNumber);
                }
            });

            break;
        }

        if (!isPeriodCompiled.get(period.formulasId)) {
            if (!account.children && !isFormula) {
                account.formulas.forEach((period) => {
                    isPeriodCompiled.set(period.formulas_id, true);
                });
                loopCount = 0;
            } else if (account.children && account.children.length > 0) {
                let currentPeriod = period.period;
                let index = account.children[0].formulas.findIndex((period) => period.period === currentPeriod);

                let isEachAccountInPeriodCompiled = true;
                account.children.forEach((child) => {
                    if (isEachAccountInPeriodCompiled) {
                        isEachAccountInPeriodCompiled = isPeriodCompiled.has(child.formulas[index].formulas_id);
                    }
                });

                if (isEachAccountInPeriodCompiled) {
                    let accountValues = scenario.values.get(account.account_number);
                    let sum = 0;

                    account.children.forEach((child) => {
                        const childValues = scenario.values.get(child.account_number);
                        let rollUp = scenario.roll_up?.get(child.account_number);

                        if (isNaN(+childValues[index].formula)) {
                            // no value - pass
                        } else if (scenario.roll_up !== null && rollUp !== undefined && rollUp[1] === 'S') {
                            sum = sum - +childValues[index].formula;
                        } else if (scenario.roll_up !== null && rollUp !== undefined && rollUp[1] === 'I') {
                            // independent - pass
                        } else {
                            sum = sum + +childValues[index].formula;
                        }
                    });
                    accountValues[index].formula = sum.toString();

                    scenario.values.set(account.account_number, accountValues);
                    isPeriodCompiled.set(period.formulasId, true);
                    loopCount = 0;
                } else {
                    loopCount += 1;
                    periodQueue.push(period);
                }

                let isAccountFormulasCompiled = account.formulas
                    .map((period) => {
                        return isPeriodCompiled.get(period.formulas_id);
                    })
                    .every((period) => period === true);

                if (isAccountFormulasCompiled) {
                    let accountValues = scenario.values.get(account.account_number);

                    if (account.carry) {
                        for (let i = 1; i < accountValues.length; i++) {
                            accountValues[i].formula = +accountValues[i].formula + +accountValues[i - 1].formula;
                        }
                    }
                }
            } else {
                const currentPeriod = period.period;
                const index = account.formulas.findIndex((period) => period.period === currentPeriod);
                const accountNumbers = retrieveAccountNumbers(account.formulas[index].formula);

                let isEachAccountInPeriodCompiled = true;
                let isFormulaAccountExisting = true;
                let currentValues = {};

                accountNumbers.forEach((accountNumber) => {
                    const offset = +(/(-\d)/g.test(accountNumber) ? accountNumber.match(/(-\d)/g)[0] : 0);
                    const currentAccountNumber = accountNumber.replace(/(\[-\d\])/g, '');
                    const currentAccount = allAccounts.get(currentAccountNumber);

                    isFormulaAccountExisting = currentAccount !== undefined ? true : false;

                    if (isFormulaAccountExisting) {
                        const currentAccountValues = [...scenario.values.get(currentAccount.account_number)];
                        const formuladId =
                            currentAccount.formulas[index + offset] !== undefined
                                ? currentAccount.formulas[index + offset].formulas_id
                                : currentAccount.formulas[index + offset];

                        if (isPeriodCompiled.get(formuladId) === false && index + offset > 0) {
                            isEachAccountInPeriodCompiled = false;
                        }

                        if (isEachAccountInPeriodCompiled) {
                            const currentValue = currentAccountValues[index + offset];

                            currentValues[accountNumber] = currentValue !== undefined ? +currentValue.formula : 'N/A';
                        }
                    }
                });

                if (!isFormulaAccountExisting) {
                    account.formulas.forEach((formula) => {
                        let newAccountsNotExisting = checkAccountNumberExistance(formula.formula, allAccounts);

                        newAccountsNotExisting.forEach((accountNotExisting) => {
                            if (!accountsNotExisting.includes(accountNotExisting)) {
                                accountsNotExisting.push(accountNotExisting);
                            }
                        });
                    });
                    break;
                }

                if (account.formulas[index].formula === '') {
                    isPeriodCompiled.set(period.formulasId, true);
                    loopCount = 0;
                } else if (isEachAccountInPeriodCompiled) {
                    let formula = account.formulas[index].formula.replace(/[{}]/g, '');
                    let replacementIndex = 0;
                    let replacement = 'x';

                    for (const accountNumber in currentValues) {
                        if (Object.keys(currentValues).length > Parser.parse(formula).variables().length) {
                            formula = formula.replace(accountNumber, replacement + replacementIndex);
                        } else {
                            formula = formula.replaceAll(accountNumber, replacement + replacementIndex);
                        }
                        currentValues[replacement + replacementIndex] = currentValues[accountNumber];

                        delete currentValues[accountNumber];
                        replacementIndex++;
                    }

                    let newValues = [...scenario.values.get(account.account_number)];
                    newValues[index].formula = Parser.parse(formula).evaluate(currentValues);

                    if (account.carry) {
                        for (let i = 1; i < newValues.length; i++) {
                            newValues[i] = newValues[i] + newValues[i - 1];
                        }
                    }

                    scenario.values.set(account.account_number, newValues);
                    isPeriodCompiled.set(period.formulasId, true);
                    loopCount = 0;
                } else {
                    loopCount += 1;
                    periodQueue.push(period);
                }
            }
        }
    }

    return {
        accountsNotExisting: accountsNotExisting,
        accountsCircular: accountsCircular,
    };
}
